module.exports = __webpack_public_path__ + "img/U1F425.a18af59c.png";